export default __webpack_public_path__ + "static/media/user-solid.dff4d244.svg";